export default {
  loading: { to: '/loading' },
  home: {
    to: '/',
    name: 'Domov',
  },
  homeDomov: {
    to: '/domov',
    name: 'Domov',
  },
  pravnePredpisy: {
    to: '/pravne-predpisy-v-jazyku-narodnostnych-mensin',
    name: 'Právne predpisy v jazykoch národnostných menšín',
  },
  jazyk: {
    to: '/pravne-predpisy-v-jazyku-narodnostnych-mensin/jazyk/:id',
    withParams: (id: string): string => `/pravne-predpisy-v-jazyku-narodnostnych-mensin/jazyk/${id}`,
    name: 'Cudzí Jazyk',
  },
  najcastejsieOtazky: {
    to: '/najcastejsie-otazky',
    name: 'Najčastejšie otázky',
  },
  prirucky: {
    to: '/pouzivatelske-prirucky',
    name: 'Používateľské príručky',
  },
  nahlasenieChyby: {
    to: '/nahlasenie-chyby',
    name: 'Nahlásenie chyby',
  },
  informacieOCookies: {
    to: '/informacie-o-cookies',
    name: 'Informácie o cookies',
  },
  verziaSlovlexu: {
    to: '/verzia-slovlexu',
    name: 'Verzia Slov-Lexu',
  },
  vyhladavaniePravnychPredpisov: {
    to: '/ezbierky/vyhladavanie-pravnych-predpisov',
    name: 'Zobraziť všetky predpisy',
  },
  legislativneProcesy: {
    to: '/elegislativa/legislativne-procesy',
    name: 'Zobraziť všetky procesy',
  },
  predbezneInformacie: {
    to: '/elegislativa/predbezne-informacie',
    name: 'Zobraziť všetky predbežné informácie',
  },
  vyhlasenieOPristupnosti: {
    to: '/vyhlasenie-o-pristupnosti',
    name: 'Vyhlásenie o prístupnosti',
  },
  vyhlasovanieVZbierke: {
    to: '/vyhlasovanie-v-zbierke',
    name: 'Vyhlasovanie v Zbierke zákonov SR',
  },
  kontakt: {
    to: '/kontakt',
    name: 'Kontakt',
  },
  aktuality: {
    to: '/aktuality',
    name: 'Aktuality',
    detail: {
      to: '/aktuality/:id',
      withParams: (id: string): string => `/aktuality/${id}`,
      name: 'Detail aktuality',
    },
  },
};
